import { Icon } from '@chakra-ui/react';
import React, { memo } from 'react';
import { Marker } from 'react-map-gl';

import { IconLocationPinStart } from 'assets/icons';

interface IStartLocationMarkerProps {
  latitude: number;
  longitude: number;
  userId: number;
  handleMarkerClick: (userId: number, longitude: number, latitude: number) => void;
}

const StartLocationMarker: React.FC<IStartLocationMarkerProps> = ({
  latitude,
  longitude,
  handleMarkerClick,
  userId,
}) => {
  return (
    <Marker latitude={latitude} longitude={longitude} offset={[0, -5]}>
      <Icon
        as={IconLocationPinStart}
        fontSize="3xl"
        onClick={() => handleMarkerClick(userId, longitude, latitude)}
        cursor="pointer"
      />
    </Marker>
  );
};

export default memo(StartLocationMarker);
